import { render, staticRenderFns } from "./InventoryTables.vue?vue&type=template&id=13154fa0&"
import script from "./InventoryTables.vue?vue&type=script&lang=js&"
export * from "./InventoryTables.vue?vue&type=script&lang=js&"
import style0 from "./InventoryTables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports